import apiService from './api';

export interface UserProfileDetails {
  phone?: string;
  apartment?: string;
  complex?: string;
  complexId?: string;
  coefficient?: number | string;
  documentType?: string;
  document?: string;
  address?: string;
}

export interface MyProfileUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  isActive: boolean;
  managedComplexId?: string | null;
  managedComplexName?: string | null;
  assignedComplexes?: Array<{ id: string; name: string }>;
  profile?: UserProfileDetails;
}

interface UserByIdResponse {
  success: boolean;
  message?: string;
  user: MyProfileUser;
}

interface MutationResponse {
  success: boolean;
  message?: string;
}

class ProfileService {
  async getMyProfile(userId: string): Promise<MyProfileUser> {
    const response = await apiService.getUserById(userId);
    const data = response.data as UserByIdResponse;

    if (!data.success || !data.user) {
      throw new Error(data.message || 'No se pudo cargar el perfil');
    }

    return data.user;
  }

  async updateMyBasicInfo(
    userId: string,
    payload: { firstName: string; lastName: string }
  ): Promise<void> {
    const response = await apiService.updateUser(userId, payload);
    const data = response.data as MutationResponse;

    if (!data.success) {
      throw new Error(data.message || 'No se pudo actualizar la información básica');
    }
  }

  async updateMyPhone(userId: string, phone: string): Promise<void> {
    const response = await apiService.api.put(`/users/${userId}/profile`, { phone });
    const data = response.data as MutationResponse;

    if (!data.success) {
      throw new Error(data.message || 'No se pudo actualizar el teléfono');
    }
  }

  async changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }): Promise<void> {
    const response = await apiService.changePassword(payload);
    const data = response.data as MutationResponse;

    if (!data.success) {
      throw new Error(data.message || 'No se pudo cambiar la contraseña');
    }
  }
}

export const profileService = new ProfileService();
